const Content = ({ children, headerSpacing }) => {
  const style = {};
  if (headerSpacing) {
    style.paddingTop = "47px";
  }
  return <div className="content d-flex flex-column w-100" style={style}>{children}</div>;
};
export default Content;